var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "convertREPtoPM", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content p-15" },
          [
            _c("div", { staticClass: "modal-header deactiveModal-bgcolor" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#convertREPtoPM",
                  },
                  on: { click: _vm.reset },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _c("div", { staticClass: "modal-body desc-text p-0 pt-15 pb-15" }, [
              _c(
                "div",
                { staticClass: "align-right" },
                [
                  _c(
                    "el-popover",
                    {
                      staticClass: "info-icon-class ml-5",
                      attrs: {
                        "popper-append-to-body": "false",
                        placement: "bottom-end",
                        trigger: "click",
                        "popper-class":
                          "popup-background tootip-custom-small-width-class",
                      },
                      on: {
                        show: function ($event) {
                          _vm.infoActive = true
                        },
                        hide: function ($event) {
                          _vm.infoActive = false
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "content" }, [
                        _vm._v(
                          ' By converting a user profile from "REP PM" to "PM", the user will: '
                        ),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Lose access to all RAMS representation accounts."
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              "Lose access to already assigned Smart Builder projects."
                            ),
                          ]),
                          _c("li", [
                            _vm._v("Get access to the selected accounts."),
                          ]),
                        ]),
                      ]),
                      !_vm.infoActive
                        ? _c("img", {
                            staticClass: "info-img",
                            attrs: {
                              slot: "reference",
                              src: "/static/images/icons/info_icon.svg",
                              alt: "info-icon",
                            },
                            slot: "reference",
                          })
                        : _vm._e(),
                      _vm.infoActive
                        ? _c("img", {
                            staticClass: "info-img",
                            attrs: {
                              slot: "reference",
                              src: "/static/images/icons/info_icon_active.svg",
                              alt: "infoactive-icon",
                            },
                            slot: "reference",
                          })
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "title-text" }, [
                _vm._v(
                  " Are you sure you would like to convert the REP PM to a PM? If yes, please select account(s) for the PM to be assigned to (a PM needs to be assigned to at least one account). "
                ),
              ]),
              _c("div", { staticClass: "row ml-0 mr-0 mt-20" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4 mt-8 mb-10 pl-0" },
                  [_vm._v("Select Account(s):")]
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-8 search p-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.enteredAccountName,
                        expression: "enteredAccountName",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "search-input form-control dropdown-toggle",
                    attrs: {
                      type: "text",
                      placeholder: "Account Name",
                      "data-toggle": "dropdown",
                    },
                    domProps: { value: _vm.enteredAccountName },
                    on: {
                      keyup: function ($event) {
                        _vm.loadedUser = true
                        _vm.getAccountsListForAccountSearch()
                      },
                      focus: function ($event) {
                        _vm.loadedUser = true
                        _vm.getAccountsListForAccountSearch()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.enteredAccountName = $event.target.value.trim()
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _c("i", { staticClass: "fa fa-search" }),
                  _vm.enteredAccountName
                    ? _c(
                        "span",
                        {
                          staticClass: "search-reset reset-close-xs",
                          on: {
                            click: function ($event) {
                              _vm.enteredAccountName = ""
                            },
                          },
                        },
                        [
                          _c("base-icon", {
                            staticClass: "icon-close",
                            attrs: { icon: "close_icon" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.enteredAccountName.length > 1 && !_vm.loadedUser
                    ? _c("div", { staticClass: "col-xs-12 dropdown-menu" }, [
                        _vm.accountList.length
                          ? _c(
                              "ul",
                              _vm._l(
                                _vm.accountList,
                                function (account, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      on: {
                                        click: function ($event) {
                                          return _vm.setAccountFieldValues(
                                            account
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(account.account_name)),
                                      ]),
                                      _c("span", { staticClass: "float-rt" }, [
                                        _vm._v(_vm._s(account.account_id)),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _c("ul", { staticClass: "col-xs-12 pb-0" }, [
                              _c("li", { staticClass: "bg-smoke-white" }, [
                                _vm._v("No Accounts available."),
                              ]),
                            ]),
                      ])
                    : _vm._e(),
                ]),
                _vm.selectedAccounts.length
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 mt-20" },
                      _vm._l(_vm.selectedAccounts, function (account, index) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticClass: "selected-names text-capitalize",
                          },
                          [
                            _vm._v(" " + _vm._s(account.account_name) + " "),
                            _c("img", {
                              staticClass: "ml-10 cursor-pointer",
                              attrs: {
                                src: "/static/images/icons/close_blue_icon.svg",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectedAccounts.splice(index, 1)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "modal-footer deactiveModal-bgcolor pl-0 pr-0" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button",
                        attrs: {
                          "data-toggle": "modal",
                          "data-target": "#convertREPtoPM",
                        },
                        on: { click: _vm.reset },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-blue-button",
                        attrs: {
                          href: "#ConfirmationModal",
                          disabled: !_vm.selectedAccounts.length,
                        },
                        on: { click: _vm.convertRepToPM },
                      },
                      [_vm._v(" Convert ")]
                    ),
                  ]
                ),
              ]
            ),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }